const addUrlParam = (url, name, value) => {
	if (!value || !name) {
		return url;
	}
	const last = url.charAt(url.length - 1);
	url += (last !== "?" ? "&" : "") + `${name}=${encodeURIComponent(value)}`;
	return url;
};
export default addUrlParam;
